import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button, Col } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";
import {
  get_pages,
  update_experiences_in_section_from_pages,
} from "../../../../../store/actions/Experience/adminExperienceAction";
import { useDispatch, useSelector } from "react-redux";
import NoContent from "../../../../reusableComponents/NoContentComponent";
import { Toggle } from "../../../superAdminReusable/reusableSuperAdminButton/Toggle";
import { SuperAdminDeleteExpCurationPage } from "./DeletionModal";
import { GET_PAGE_EXPERIENCE } from "../../../../../store/types";
import { successAlert } from "../../../../../function/alert";
const CurationPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const auth = useSelector((state) => state.auth);
  const pages = useSelector((state) => state?.superAdminExperience?.pages);
  const getPages = () => {
    dispatch(get_pages(auth?.user?.accessToken, "page"));
  };
  useEffect(() => {
    if (!pages?.length || pages?.length < 2) getPages();
  }, []);

  const changeHandler = (status, _id, type) => {
    update_experiences_in_section_from_pages(
      _id,
      {
        status: status,
      },
      auth?.user?.accessToken,
      type,
      getPages
    );
  };
  const onSuccessDelete = (id) => {
    let _pages = pages.filter((page) => page?._id != id);
    dispatch({ type: GET_PAGE_EXPERIENCE, payload: _pages });
    successAlert("Page deleted successfully..!");
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Create Page for Experience Curation
                  <br />
                </div>
              </div>
              <div className="d-flex justify-content-end align-items-center">
                <div className="text-right">
                  <NavLink
                    to="/superadmin/experience/addpages"
                    className="mr-4 px-5 py-2 btn addBtnRed f14-700"
                    style={{
                      color: "#f26856",
                      boxShadow: "0px 3px 6px #6E6E6E21",
                    }}
                  >
                    Add Page
                  </NavLink>
                </div>
              </div>
              <div className="Row">
                <div
                  className={`mr-4 px-0 text-grayLink f12-700 btn btn-link active`}
                >
                  Create Page ID
                </div>
              </div>
              <hr className="p-0 m-0" />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main mt-2">
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "20%" }} className="f12-400">
                        Page ID
                      </td>
                      <td style={{ width: "40%" }} className="f12-400">
                        Description
                      </td>
                      <td style={{ width: "20%" }} className="f12-400">
                        Position
                      </td>
                      <td style={{ width: "10%" }} className="f12-400">
                        Active
                      </td>
                      <td style={{ width: "10%" }} className="f12-400"></td>
                    </tr>
                  </thead>
                  <tbody className="w-100 super-admin-all-vendor-main-table-body">
                    {pages?.length ? (
                      pages?.map((data) => {
                        return (
                          <>
                            <Body
                              data={data}
                              history={history}
                              changeHandler={changeHandler}
                              onSuccessDelete={onSuccessDelete}
                            />
                          </>
                        );
                      })
                    ) : (
                      <NoContent />
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CurationPage;

const Body = ({ data, history, changeHandler, onSuccessDelete }) => {
  const [show, setShow] = useState(false);
  return (
    <>
      <tr className="w-100 p-0" style={{ cursor: "pointer" }}>
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className={"sd_body_css"}>
              <tr onClick={() => setShow(!show)}>
                <td style={{ width: "20%" }}>
                  <div>
                    <h5 className="font_16_m mt-3">{data?.page_id || ""}</h5>
                  </div>
                </td>
                <td style={{ width: "40%" }}>
                  <h3 className="font_20_m">{data?.description || ""}</h3>
                </td>
                <td style={{ width: "20%" }}>
                  <h3 className="font_20_m">{data?.position || ""}</h3>
                </td>
                <td style={{ width: "10%" }}>
                  <h3 className="font_20_m">
                    <Toggle
                      toggleFunction={() =>
                        changeHandler(!data?.status, data?._id)
                      }
                      checked={data?.status}
                    />
                  </h3>
                </td>
                <td style={{ width: "10%" }}>
                  <Button
                    variant="danger"
                    onClick={(e) =>
                      history.push({
                        pathname: `/superadmin/experience/pages/${data?._id}`,
                        state: data?.description,
                      })
                    }
                  >
                    Edit Page
                  </Button>
                </td>
              </tr>
              {show && (
                <>
                  <tr className="sd_accordion_body p-1">
                    <td style={{ width: "20%" }}>
                      <div className="f12-400">More Actions</div>
                      <div className="d-flex align-items-center mt-2">
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          onClick={() =>
                            history.push(
                              `/superadmin/experience/editpages/${data?._id}`
                            )
                          }
                        >
                          <Image
                            src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </Button>
                        <SuperAdminDeleteExpCurationPage
                          id={data?._id}
                          onSuccess={onSuccessDelete}
                          active={data?.status}
                          title="Request for Deletion"
                          subTitle="Are you sure you want to delete this Page ID?"
                        />
                      </div>
                    </td>
                    <td style={{ width: "25%" }}>
                      <div className="f12-400">Total Number of Sections</div>
                      <div className="f12-500 mt-3">
                        {data?.sections_count || 0}
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </>
  );
};
